import React, { useState, useEffect, useRef } from "react";
import { getCustomerFields2 } from "../../../../Services/fieldsServices";
import { updateFieldConfig, confirmFieldReset } from "../../../../Services/tooltipService";
import Fields from "./Fields";
import Modules from "./Modules";
import Tabs from "./Tabs";
import Sections from "./Sections";
import ButtonElement from '../../../../Components/UiComponents/ButtonElement';
import { Dialog } from 'primereact/dialog';
import ToastElement from '../../../../Components/UiComponents/ToastElement';
import { TabView, TabPanel } from 'primereact/tabview';
import { Accordion, AccordionTab } from 'primereact/accordion';
import Loader from "../../../../Components/UiComponents/Loader";
import { useNavigate } from "react-router-dom";
import PlaylistVideos from '../../../../Components/Videos/PlaylistVideos';
import _ from "lodash";

export default function FieldConfig() {
    const projectStages = [{ label: 'Sector 1', value: 'sector1' }, { label: 'Sector 2', value: 'sector2' }];
    const [fieldConfigData, setFieldConfigData] = useState([]);
    const [customerId, setCustomerId] = useState(null);
    const [field, setField] = useState([]);
    const [subModule, setSubModule] = useState([]);
    const [selectedSubModule, setSelectedSubModule] = useState(null);
    const [selectedSubModuleField, setSelectedSubModuleField] = useState([]);
    const [allData, setAllData] = useState([]);
    const [deleteProductDialog, setDeleteProductDialog] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);
    const [activeIndex1, setActiveIndex1] = useState(0);
    const [newModule, setNewModule] = useState({});
    const [loading, setLoading] = useState(false);
    const [showVideo, setShowVideo] = useState(false);
    const navigate = useNavigate()
    const toastRef = useRef();

    useEffect(() => {
        // Fetching end user data from local storage
        const enduserStr = localStorage.getItem("enduser");

        // Checking if end user data exists in local storage
        if (enduserStr) {
            // Parsing end user data
            const enduser = JSON.parse(enduserStr);

            // Extracting customer information from end user data
            const customer = enduser.customer;

            // Setting customer ID state
            setCustomerId(customer);
        } else {
            // Logging if no end user data found in local storage
            navigate("/login")
            localStorage.clear()
        }

        getFieldConfig();
    }, [customerId]);

    useEffect(() => {
        if (selectedSubModuleField && field && subModule) {
            let obj1 = selectedSubModuleField;
            let obj2 = field;
            let obj3 = subModule;

            let newKey = 'Modules';
            let newKey1 = 'Tabs';
            let combined = { ...obj1, [newKey]: obj2, [newKey1]: obj3 };
            setNewModule(combined)
        }

    }, [selectedSubModuleField, field, subModule])

    // Function to get customer fields data
    const getFieldConfig = async () => {
        try {
            if (customerId === null) {
                return;
            }
            setLoading(true)
            if (customerId !== null) {
                const customerDataResponse = await getCustomerFields2(customerId)
                setSelectedSubModuleField(customerDataResponse?.data?.cust[0]?.modules[0]?.sub_modules[0])
                setFieldConfigData(customerDataResponse?.data?.cust[0]?.modules);
                setSubModule(customerDataResponse?.data?.cust[0]?.modules[0]?.sub_modules)
                setField(customerDataResponse?.data?.cust[0]?.modules[0])
                setSelectedSubModule(customerDataResponse?.data?.cust[0]?.modules[0]?.sub_modules[0]?.display_name)
                setAllData(customerDataResponse?.data?.cust[0])
                setActiveIndex(0)
                setActiveIndex1(0)
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        } finally {
            setLoading(false)
        }
    };

    const selectField = (value) => {
        const selected = fieldConfigData.find(sub => sub.display_name === value.display_name);
        if (selected) {
            setField(selected);
            setSubModule(selected.sub_modules);
            setSelectedSubModuleField(selected.sub_modules[0]);
        }
    };

    const selectedSubModules = (value) => {
        const selected = subModule.find(sub => sub.display_name === value.display_name);
        if (selected) {
            setSelectedSubModuleField(selected);
        }
    };

    const gettingData = (data, key) => {
        if (fieldConfigData) {
            let updatedFieldConfigData1 = JSON.parse(JSON.stringify(fieldConfigData));
            let updatedFieldConfigData = { ...allData };
            const selectedModule = updatedFieldConfigData.modules.find(sub => sub.display_name === field.display_name);
            if (selectedModule) {
                const selectedSubModule = selectedModule.sub_modules.find(sub => sub.display_name === selectedSubModuleField.display_name);
                if (selectedSubModule) {
                    selectedSubModule.fields = data;
                    setAllData(prevModules => ({
                        ...prevModules,
                        modules: prevModules.modules.map(module =>
                            module._id === field._id
                                ? {
                                    ...module,
                                    sub_modules: module.sub_modules.map(submodule =>
                                        submodule._id === selectedSubModuleField._id
                                            ? {
                                                ...submodule,
                                                [key]: data
                                            }
                                            : submodule
                                    )
                                }
                                : module
                        )
                    }));
                    setField(selectedModule)
                }
            }
        }
    };

    const gettingModuleData = (data) => {
        // Create a copy of allData to avoid direct state mutation
        let updatedAllData = { ...allData };

        // Find the index of the selected module
        const moduleIndex = updatedAllData.modules.findIndex(sub => sub._id === data._id);

        if (moduleIndex !== -1) {
            // Update the selected module's properties
            updatedAllData.modules[moduleIndex] = {
                ...updatedAllData.modules[moduleIndex],
                // Update the fields you need here
                ...data
            };

            // Set the updated data back to state
            setAllData(updatedAllData);
        } else {
            console.log('Module not found');
        }

    };

    const gettingSubModuleData = (data) => {

    }

    const updateField = async () => {
        try {
            if (customerId === null) {
                return;
            }
            setLoading(true)
            // Call
            const response = await confirmFieldReset(customerId);
            const data = response.data;

            if (response && response?.status === 200) {
                toastRef.current.showToast({
                    type: 'success',
                    message: `Fields/Sections Info Updated Successfully`
                });
            }
            else {
                toastRef.current.showToast({
                    type: 'error',
                    message: `Error: failed to update`
                });
            }

            setDeleteProductDialog(false);
            getFieldConfig();

        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        } finally {
            setLoading(false)
        }
    }


    const load = async () => {
        try {
            if (customerId === null) {
              return;
            }
            const customerDataResponse = await updateFieldConfig(customerId, [allData])
            if (customerDataResponse && customerDataResponse?.status === 200) {
                toastRef.current.showToast({
                    type: 'success',
                    message: `Fields/Sections Info Updated Successfully`
                });
            }
            else {
                toastRef.current.showToast({
                    type: 'error',
                    message: `Error: failed to update`
                });
            }
            getFieldConfig()
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: "Failed to fetch customer data"
            });
        }
    }

    const confirmUpdateProduct = () => {
        setDeleteProductDialog(true);
    };

    const hideUpdateProductDialog = () => {
        setDeleteProductDialog(false);
    };


    // Define the footer for the delete product dialog with action buttons
    const deleteProductDialogFooter = (
        <React.Fragment>
            {/* Button to cancel the delete action */}
            <ButtonElement
                label="No"
                outlined
                onClick={hideUpdateProductDialog}
            />
            <ButtonElement
                label="Yes"
                severity="success"
                onClick={updateField}
            />
        </React.Fragment>
    );

    const moduleTemplate = (value) => {
        const selected = fieldConfigData.find(sub => sub.display_name === fieldConfigData[value.index].display_name);
        if (selected) {
            setField(selected);
            setSubModule(selected.sub_modules);
            setSelectedSubModuleField(selected.sub_modules[0]);
            setActiveIndex(value.index)
        }
    };

    const submoduleTemplate = (value) => {
        const selected = subModule.find(sub => sub.sub_module_name === fieldConfigData[activeIndex].sub_modules[value.index].sub_module_name);
        if (selected) {
            setSelectedSubModuleField(selected);
            setActiveIndex1(value.index)
        }
    };

    const renderFooter = () => {
        return (
            <div className="cancel-footer">
                <div className='align-center justify-end pb-0'>
                    <ButtonElement label="No" className="cancel-new-button" onClick={hideUpdateProductDialog} />
                    <ButtonElement type="submit" label="Yes" className="save-button" onClick={updateField} />
                </div>
            </div>
        );
    }

    const capitalizeFirstLetter = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    const handleButtonClick = () => {
        setShowVideo(true);
    };
    
    const closeVideo = () => {
        setShowVideo(false);
    };

    return (
        <div className="group-table-component">
            <ToastElement ref={toastRef} />
            <Loader loading={loading} />
            <div className="header-design mt-20">
                <p className="fs-16 fw-600 mar-b-3">Field Config</p>
                <ButtonElement className="upload-button" type="button" icon="pi pi-video" onClick={handleButtonClick}></ButtonElement>
            </div>

            <div className='mt-30'>
                <p className="fs-14 mar-b-3">Modules:</p>
                <TabView activeIndex={activeIndex} onTabChange={(e) => moduleTemplate(e)}>
                    {
                        fieldConfigData.length > 0 && fieldConfigData.map(m => {
                            return (
                                <TabPanel header={m.display_name} key={m._id} >
                                    {/* <div className='vertical-tabview'> */}
                                    <div className='vertical-tabview'>
                                        <p className="fs-14 mar-b-3">Tabs:</p>
                                        <TabView activeIndex={activeIndex1} onTabChange={(e) => submoduleTemplate(e)}>
                                            {
                                                subModule.length > 0 && subModule.map(sm => {
                                                    return (
                                                        <TabPanel header={sm.display_name} key={sm._id}>
                                                            <div className="app-container">
                                                                <div className="flex-1">
                                                                    <div className="width-100">
                                                                        <div>
                                                                            <div className='d-flex justify-between align-center'>
                                                                                <p className='bread-crumb'>{m.display_name + " " + '>' + " " + sm.display_name}</p>
                                                                                <div className="cancel-footer d-flex justify-end">
                                                                                    <div className='align-center justify-end pb-0'>
                                                                                        <ButtonElement label="Reset" className="cancel-new-button" onClick={confirmUpdateProduct} />
                                                                                        <ButtonElement type="submit" label="Save" className="save-button" onClick={load} />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className='mt-10'>
                                                                                {
                                                                                    Object.keys(newModule).map((key) => {
                                                                                        if ((key === 'fields' && selectedSubModuleField?.fields?.length > 0) || (key === 'sections' && selectedSubModuleField?.sections?.length > 0) || (key === 'Modules' && !_.isEmpty(field)) || (key === 'Tabs' && subModule?.length > 0)) {
                                                                                            return (
                                                                                                <div key={key} className='mt-10'>
                                                                                                    <Accordion activeIndex={0}>
                                                                                                        <AccordionTab header={capitalizeFirstLetter(key)} disabled>
                                                                                                            {
                                                                                                                key === 'fields' && (
                                                                                                                    <div>
                                                                                                                        <Fields fields={selectedSubModuleField} getData={(data) => gettingData(data, key)} />
                                                                                                                    </div>
                                                                                                                )
                                                                                                            }
                                                                                                            {
                                                                                                                key === 'sections' && (
                                                                                                                    <div>
                                                                                                                        <Sections fields={selectedSubModuleField?.sections} />
                                                                                                                    </div>
                                                                                                                )
                                                                                                            }
                                                                                                            {
                                                                                                                key === 'Modules' && (
                                                                                                                    <div>
                                                                                                                        <Modules fields={field} getData={gettingModuleData} />
                                                                                                                    </div>
                                                                                                                )
                                                                                                            }
                                                                                                            {
                                                                                                                key === 'Tabs' && (
                                                                                                                    <div>
                                                                                                                        <Tabs fields={subModule} getData={gettingSubModuleData} />
                                                                                                                    </div>
                                                                                                                )
                                                                                                            }
                                                                                                        </AccordionTab>
                                                                                                    </Accordion>
                                                                                                </div>
                                                                                            );
                                                                                        }
                                                                                        return null;
                                                                                    })
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </TabPanel>
                                                    )
                                                })
                                            }
                                        </TabView>
                                    </div>
                                </TabPanel>
                            )
                        })
                    }
                </TabView>
            </div>
            <Dialog visible={deleteProductDialog} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header="Confirm" modal footer={renderFooter} onHide={hideUpdateProductDialog} className="table-dialog width-32" draggable={false}>
                <div className="confirmation-content">
                    {/* <i className="pi pi-exclamation-triangle mr-3 dilog-box" /> */}
                    <span className="table-description">
                        This action will reset to default config this changes will not be revert back. Do you want to proceed?
                    </span>
                </div>
            </Dialog>

            <Dialog id="videoModal" visible={showVideo}
				breakpoints={{
				'1200px': '80vw',    // Larger modal on bigger screens
				'1024px': '85vw',    // Slightly smaller for medium screens
				'769': '90vw',     // Responsive on tablets
				'641px': '95vw',     // Almost full-width on mobile
				}}
				modal className="table-dialog width-32" draggable={false} width="800px" height="500px" onHide={closeVideo}
			>
				<div className="video-overlay">
					<div className="video-container">
						<PlaylistVideos playlistId={process.env.REACT_APP_CONTROL_PANEL_PLAYLIST_ID} apiKey={process.env.REACT_APP_GOOGLE_API_KEY} module="control_panel_field_config" />
					</div>
				</div>
			</Dialog>
        </div>
    )
}
